<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding: 10px">
      <el-form class="fr ac">
        <div style="width: 300px">
          <el-input placeholder="请输入手机号码" v-model="search.mobile" />
        </div>

        <el-date-picker
          class="ml20"
          v-model="daterange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        ></el-date-picker>

        <div class="ml40">
          <el-button @click="getContributeMoneyList" type="primary"
            >查询</el-button
          >
        </div>
        <!--给按钮绑定事件-->

        <div class="ml40">
          <el-button @click="exportExcel" type="primary">导出</el-button>
        </div>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table
      id="out-table"
      :data="contribute_money_list"
      highlight-current-row
    >
      <el-table-column prop="id" width="60" label="id"></el-table-column>
      <!-- <el-table-column prop='openid' label='捐款人' sortable>
        <template slot-scope='scope'>
          <img style='width:100px;height:100px' :src='scope.row.img' alt />
        </template>
      </el-table-column>-->
      <el-table-column
        prop="con_project_name"
        label="捐款项目"
        sortable
      ></el-table-column>
      <el-table-column prop="username" label="捐款人" sortable>
        <template slot-scope="scope">
          <div v-if="scope.row.con_type == 0">
            <span v-if="scope.row.is_real_name == 1">{{
              scope.row.username
            }}</span>
            <span v-if="scope.row.is_real_name == 0">爱心人士</span>
          </div>
          <div v-if="scope.row.con_type == 1">
            <span v-if="scope.row.is_real_name == 1">{{
              scope.row.company_name
            }}</span>
            <span v-if="scope.row.is_real_name == 0">爱心单位</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="username"
        label="联系人"
        sortable
      ></el-table-column>
      <el-table-column prop="mobile" label="手机" sortable></el-table-column>
      <el-table-column prop="tel" label="座机" sortable></el-table-column>
      <el-table-column
        prop="contact_address"
        label="联系地址"
        sortable
      ></el-table-column>
      <el-table-column prop="email" label="邮箱" sortable></el-table-column>
      <el-table-column prop="username" label="捐款方" sortable>
        <template slot-scope="scope">
          <span v-if="!scope.row.company_name">个人</span>
          <span v-if="scope.row.company_name">单位</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="company_name"
        label="公司名称"
        sortable
      ></el-table-column>
      <el-table-column prop="username" label="实名公开" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.is_real_name == 0">否</span>
          <span v-if="scope.row.is_real_name == 1">是</span>
        </template>
      </el-table-column>

      <el-table-column prop="username" label="收据" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.is_receipt == 0">否</span>
          <span v-if="scope.row.is_receipt == 1">是</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="receipt_company_name"
        label="收据抬头"
        sortable
      ></el-table-column>
      <el-table-column prop="money" label="金额" sortable></el-table-column>

      <el-table-column
        prop="create_time"
        label="捐款时间"
        sortable
      ></el-table-column>
    </el-table>

    <div class="fr jc ac">
      <el-pagination
        :current-page.sync="page"
        :page-size.sync="page_size"
        :page-sizes="[10, 100, 500, 1000]"
        @current-change="getContributeMoneyList"
        @size-change="getContributeMoneyList"
        background
        layout="sizes,prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </section>
</template>

<script>
// 引入导出Excel表格依赖
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
  data() {
    return {
      daterange: [],
      page: 1,
      page_size: 10,
      total: 100,
      contribute_money_list: [],
      search: {
        mobile: '',
      },
    }
  },
  methods: {
    //获取列表
    getContributeMoneyList() {
      let param = {
        start_time: this.daterange[0],
        end_time: this.daterange[1] ? this.daterange[1] + ' 23:59:59' : null,
        token: sessionStorage.getItem('token'),
        page: this.page,
        page_size: this.page_size,
        mobile: this.search.mobile,
        is_pay: 1,
      }
      //  let loading =this.$loading();
      this.post('contributeMoney/getContributeMoneyList', param).then((res) => {
        // loading.close()
        this.contribute_money_list = res.data
        this.total = res.total
        console.log(res)
      })
    },
    //定义导出Excel表格事件
    exportExcel() {
      /* 从表生成工作簿对象 */
      console.log(XLSX)
      var wb = XLSX.utils.table_to_book(document.querySelector('#out-table'))
      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array',
      })
      try {
        FileSaver.saveAs(
          //Blob 对象表示一个不可变、原始数据的类文件对象。
          //Blob 表示的不一定是JavaScript原生格式的数据。
          //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
          //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
          new Blob([wbout], { type: 'application/octet-stream' }),
          //设置导出文件名称
          'sheet.xlsx'
        )
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbout)
      }
      return wbout
    },
  },
  mounted() {
    this.getContributeMoneyList()
  },
}
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>